import { Seat } from 'types/Location'

export const generateSelectedSeats = (rows: number, columns: number): Omit<Seat, 'seat_id'>[] => {
    const seats: Omit<Seat, 'seat_id'>[] = []
    for (let row = 0; row < rows; row++) {
        for (let column = 0; column < columns; column++) {
            seats.push({ row, column, gallery_id: null, on_gallery: false })
        }
    }
    return seats
}

export const calculateDimensions = (totalSeats: number): { rows: number; columns: number } => {
    const columns = Math.ceil(Math.sqrt(totalSeats))
    const rows = Math.ceil(totalSeats / columns)
    return { rows, columns }
}

export const generateSeats = (totalSeats: number): Omit<Seat, 'seat_id'>[] => {
    const { rows, columns } = calculateDimensions(totalSeats)
    const seats: Omit<Seat, 'seat_id'>[] = []

    let seatIndex = 0
    for (let row = 0; row < rows; row++) {
        for (let column = 0; column < columns; column++) {
            if (seatIndex < totalSeats) {
                seats.push({
                    row,
                    column,
                    gallery_id: null,
                    on_gallery: false,
                })
                seatIndex++
            } else {
                // fill with gaps if needed (optional depending on renderer)
                // no push -> empty space
            }
        }
    }

    return seats
}
